import { logger } from 'utils/logger';

import SignalRAiChatController from './SignalRAiChatController';
import SignalRAiProcessRunsController from './SignalRAiProcessRunsController';
import SignalRConnection from './SignalRConnection';
import SignalRLoanApplicationController from './SignalRLoanApplicationController';
import SignalRLoanPipelinesController from './SignalRLoanPipelinesController';
import SignalRPushNotificationsController from './SignalRPushNotificationsController';
import SignalRTeamChatController from './SignalRTeamChatController';
import SignalRTelephonyController from './SignalRTelephonyController';

export { accessTokenFactory } from './signalR.utils';

export const loanApplicationSignalRConnection = new SignalRConnection(logger);
export const loanApplicationSignalRController = new SignalRLoanApplicationController(
  loanApplicationSignalRConnection,
  logger,
);

export const loanPipelinesSignalRConnection = new SignalRConnection(logger);
export const loanPipelinesSignalRController = new SignalRLoanPipelinesController(
  loanPipelinesSignalRConnection,
  logger,
);

export const telephonySignalRConnection = new SignalRConnection(logger);
export const telephonySignalRController = new SignalRTelephonyController(
  telephonySignalRConnection,
  logger,
);

export const pushNotificationsSignalRConnection = new SignalRConnection(logger);
export const pushNotificationsSignalRController = new SignalRPushNotificationsController(
  pushNotificationsSignalRConnection,
  logger,
);

export const teamChatSignalRConnection = new SignalRConnection(logger);
export const teamChatSignalRController = new SignalRTeamChatController(
  teamChatSignalRConnection,
  logger,
);

export const aiChatSignalRConnection = new SignalRConnection(logger);
export const aiChatSignalRController = new SignalRAiChatController(aiChatSignalRConnection, logger);

export const aiProcessRunsSignalRConnection = new SignalRConnection(logger);
export const aiProcessRunsSignalRController = new SignalRAiProcessRunsController(
  aiProcessRunsSignalRConnection,
  logger,
);
